export const NotificationTemplateType={
    OrganizationSignup:"OrganizationSignup",
    OrganinzationToolTipTemplate:"OrganinzationToolTipTemplate",
    ActivityUpdated:"ActivityUpdated",
    WorkkardUpdated:"WorkkardUpdated",
    UserSignup:"UserSignup",
    SendB2BRequest:"SendB2BRequest",
    RespondB2B:"RespondB2B",
    RespondB2BSender:"RespondB2BSender",
    SendB2BContract:"SendB2BContract",
    SendB2BContractSender:"SendB2BContractSender",
    AcceptB2BContract:"AcceptB2BContract",
    AcceptB2BContractSender:"AcceptB2BContractSender",
    RejectB2BContract:"RejectB2BContract",
    RejectB2BContractSender:"RejectB2BContractSender",
    RejectB2BVersion:"RejectB2BVersion",
    AcceptB2BVersion:"AcceptB2BVersion",
    RejectB2BVersionSender:"RejectB2BVersionSender",
    AcceptB2BVersionSender:"AcceptB2BVersionSender",
    TerminateB2BContract:"TerminateB2BContract",
    SendB2BVersion:"SendB2BVersion",
    SendB2BVersionSender:"SendB2BVersionSender",
    BlockedActivityOwner:"BlockedActivityOwner",
    BlockedWKSponsor:"BlockedWKSponsor",
    BlockedOwnerSponsor:"BlockedOwnerSponsor",
    ChangedRegisterEmail:"ChangedRegisterEmail",
    RejectActivity:"RejectActivity",
    AcceptActivity:"AcceptActivity",
    BulkAcceptActivity:"BulkAcceptActivity",
    BulkRejectActivity:"BulkRejectActivity",
    ActivityProgressIncrease:"ActivityProgressIncrease",
    ActivityInProgressDecrease:"ActivityInProgressDecrease",
    ActivityComplete:"ActivityComplete",
    ActivityClose:"ActivityClose",
    NewOwnerActivity:"NewOwnerActivity",
    YouAreNewOwnerActivity:"YouAreNewOwnerActivity",
    YouAreOwnerActivity:"YouAreOwnerActivity",
    UserSponsorWorkkard:"UserSponsorWorkkard",
    YouAreSponsorWorkkard:"YouAreSponsorWorkkard",
    CreatorAddedSponsor:"CreatorAddedSponsor",
    ActivityClosedMidterm:"ActivityClosedMidterm",
    ActivityAssignedToOrg:"ActivityAssignedToOrg",
    ActivityReAssignedToOrg:"ActivityReAssignedToOrg",
    ActivityAssignedToUser:"ActivityAssignedToUser",
    ActivityAssignedToYou:"ActivityAssignedToYou",
    ActivityReassignedClose:"ActivityReassignedClose",
    ActivityReassignedToUser:"ActivityReassignedToUser",
    ActivityReassignedToYou:"ActivityReassignedToYou",
    ActivityNoteAdded:"ActivityNoteAdded",
    ActivityNoteWithFileOnlyAdded:"ActivityNoteWithFileOnlyAdded",
    ActivityNotePublished:"ActivityNotePublished",
    PrivateActivityNoteAdded:"PrivateActivityNoteAdded",
    PrivateActivityNotePublished:"PrivateActivityNotePublished",
    PrivateActivityNoteWithFileOnlyPublished:"PrivateActivityNoteWithFileOnlyPublished",
    PersonalActivityNotePrivatePublished:"PersonalActivityNotePrivatePublished",
    PersonalActivityNoteWithFileOnlyPrivatePublished:"PersonalActivityNoteWithFileOnlyPrivatePublished",
    PersonalActivityNotePublicPublished:"PersonalActivityNotePublicPublished",
    PersonalActivityNoteWithFileOnlyPublicPublished:"PersonalActivityNoteWithFileOnlyPublicPublished",
    WorkkardNoteAdded:"WorkkardNoteAdded",
    WorkkardNoteWithFileOnlyAdded:"WorkkardNoteWithFileOnlyAdded",
    WorkkardNotePublished:"WorkkardNotePublished",
    PrivateWorkkardNoteAdded:"PrivateWorkkardNoteAdded",
    PrivateWorkkardNoteWithFileOnlyAdded:"PrivateWorkkardNoteWithFileOnlyAdded",
    PrivateWorkkardNotePublished:"PrivateWorkkardNotePublished",
    PrivateWorkkardNoteWithFileOnlyPublished:"PrivateWorkkardNoteWithFileOnlyPublished",
    PersonalWorkkardNotePrivatePublished:"PersonalWorkkardNotePrivatePublished",
    PersonalWorkkardNoteWithFileOnlyPrivatePublished:"PersonalWorkkardNoteWithFileOnlyPrivatePublished",
    PersonalWorkkardNotePublicPublished:"PersonalWorkkardNotePublicPublished",
    PersonalWorkkardNoteWithFileOnlyPublicPublished:"PersonalWorkkardNoteWithFileOnlyPublicPublished",
    WorkkardWatcher:"WorkkardWatcher",
    ActivityWatcher:"ActivityWatcher",
    TodoReopen:"TodoReopen",
    TodoCompleted:"TodoCompleted",
    TodoDeleted:"TodoDeleted",
    TodoEdited:"TodoEdited",
    TodoAssigned:"TodoAssigned",
    TodoReAssigned:"TodoReAssigned",
    TodoReminder:"TodoReminder",
    UserToolTipTemplate:"UserToolTipTemplate",
    AcceptUser:"AcceptUser",
    RejectUser:"RejectUser",
    BulkOwnerChange:"BulkOwnerChange",
    BulkViewActivityOwnerChange:"BulkViewActivityOwnerChange",
    BulkViewActivityNewOwner:"BulkViewActivityNewOwner",
    BulkViewChangeActivityDueDate:"BulkViewChangeActivityDueDate",
    BulkWorkkardOwnerChange:"BulkWorkkardOwnerChange",
    BulkWorkkardOwnerChangeToYou:"BulkWorkkardOwnerChangeToYou",
    BulkViewCloseActivity:"BulkViewCloseActivity",
    BulkAssigneeChange:"BulkAssigneeChange",
    bulkactivityownerchange:"bulkactivityownerchange",
    BulkDiaryEdited:"BulkDiaryEdited",
    BulkDiaryCancelled:"BulkDiaryCancelled",
    BulkViewActivityReassignedToUser:"BulkViewActivityReassignedToUser",
    BulkViewActivityReassignedToOrg:"BulkViewActivityReassignedToOrg",
    BulkViewActivityReassignedToYou:"BulkViewActivityReassignedToYou",
    BulkViewActivityReassignedClosed:"BulkViewActivityReassignedClosed",
    BulkViewActivityAssignedToOrg:"BulkViewActivityAssignedToOrg",
    BulkViewActivityCompleted:"BulkViewActivityCompleted",
    BulkViewCompleteDiary:"BulkViewCompleteDiary",
    BulkDiaryAssigned:"BulkDiaryAssigned",
    BulkDiaryReAssigned:"BulkDiaryReAssigned",
    BlockRuleUser:"BlockRuleUser",
    WorkkardGroup:"WorkkardGroup",
    TimeFrameUpdated:"TimeFrameUpdated",
    RequestToJoinOrg:"RequestToJoinOrg",
    GrantAccess:"GrantAccess",
    ShareWorkkards:"ShareWorkkards",
    FeatureUpdate:"FeatureUpdate",
    WorkloadShift:"WorkloadShift",
    DeAssociateB2B:"DeAssociateB2B",
    RuleException:"RuleException",
    ActivityReopened:"ActivityReopened",
    TerminateB2BContractSender:"TerminateB2BContractSender",
}

export const status={
    "all": 100,
    "read": 2,
    "unRead": 1,
    "unSeen": 0
}